import React, { ReactElement } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import { AnimationBase } from './AnimationBase';
import { RippleCircle } from './RippleCircle';

export type ILoadingSpinnerProps = IQATestableProps & IStyleableProps;

export function OzLoadingSpinner (props: ILoadingSpinnerProps): ReactElement {
    const {
        'data-testid': dataTestId,
        className = '',
    }: ILoadingSpinnerProps = props;

    return (
        <div className={`flex flex-col items-center ${className}`} data-testid={dataTestId}>
            <svg
                className="bg-white-500 block m-auto"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="138px"
                height="138px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
            >
                <RippleCircle color="#ffdd00">
                    <AnimationBase attributeName="r" values="0;50" begin="0s" />
                    <AnimationBase attributeName="opacity" values="1;0" begin="0s" />
                </RippleCircle>
                <RippleCircle color="#00d5db">
                    <AnimationBase attributeName="r" values="0;50" begin="-1.7857142857142856s" />
                    <AnimationBase attributeName="opacity" values="1;0" begin="-1.7857142857142856s" />
                </RippleCircle>
            </svg>
        </div>
    );
}
